<template>
  <div>
    <div class="d-flex align-items-center justify-content-end mb-2">
      <b-button-group class="mr-1">
        <b-button
          variant="primary"
        >%</b-button>
        <b-button
          variant="outline-secondary"
          disabled
        >fixed</b-button>
      </b-button-group>
      <b-input-group style="max-width: 100px">
        <b-form-input
          v-model.number="globalRate.tax_rate"
          type="number"
          style="max-width: 60px"
          placeholder="%"
        />
        <b-input-group-append>
          <b-input-group-text>
            %
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>

      <b-button
        class="ml-1"
        variant="outline-primary"
        @click="applyToAll"
      >
        {{ $t('RtbPartnersControl.setForAll') }}
      </b-button>
    </div>

    <!-- Таблица партнёров -->
    <b-table
      :items="rtbPartners"
      :fields="fields"
      :tbody-tr-class="getRowClass"
      responsive
      bordered
      small
    >
      <template #head(subscribed)="data">
        {{ $t(data.label) }}
      </template>

      <template #head(name)="data">
        {{ $t(data.label) }}
      </template>

      <template #head(fee)="data">
        {{ $t(data.label) }}
      </template>

      <template #head(limit)="data">
        {{ $t(data.label) }}
      </template>

      <template #head(godMode)="data">
        {{ $t(data.label) }}
      </template>

      <template #cell(subscribed)="{ item }">
        <div class="d-flex align-items-center">
          <span
            :class="{'text-danger font-weight-bolder': !item.subscribed, 'text-muted': item.subscribed }"
          >off</span>
          <b-form-checkbox
            v-model="item.subscribed"
            switch
            class="ml-1"
          />
          <span
            :class="{'text-primary font-weight-bolder': item.subscribed, 'text-muted': !item.subscribed }"
          >
            on
          </span>
        </div>
      </template>

      <template #cell(godMode)="{ item }">
        <div class="d-flex justify-content-center align-items-center gap-1">
          <b-form-checkbox
            v-model="item.god_mode"
            @change="handleGodModeChange(item)"
          />
        </div>
      </template>

      <template #cell(name)="{ item }">
        <div
          class="alert mb-0"
          :class="item.status === 'active' ? 'alert-success' : 'alert-warning'"
        >
          <div class="alert-body mb-0">
            {{ item.name }}
          </div>
        </div>
      </template>

      <template #cell(fee)="{ item }">
        <div class="d-flex align-items-center">
          <b-input-group style="max-width: 130px;">
            <b-form-input
              v-model.number="item.tax_rate"
              type="number"
              min="0"
              step="0.01"
            />
            <b-input-group-append>
              <b-input-group-text>
                %
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </div>
      </template>

      <template #cell(limit)="{ item }">
        <div class="d-flex justify-content-center align-items-center gap-1">
          <b-form-checkbox
            v-model="item.hasDailyLimit"
            @change="handleDailyLimitChange(item)"
          />
          <b-input-group
            v-if="item.hasDailyLimit"
            style="max-width: 130px;"
          >
            <b-form-input
              v-model.number="item.daily_limit"
              type="number"
              min="0"
              step="0.1"
              placeholder="Лимит ($)"
              style="max-width: 60px"
            />
            <b-input-group-append>
              <b-input-group-text>
                {{ '$' }}
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {
  BButton,
  BButtonGroup,
  BFormInput,
  BTable,
  BFormCheckbox,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupText,
} from 'bootstrap-vue'

export default {
  name: 'RtbPartnersControl',
  components: {
    BButton,
    BButtonGroup,
    BFormInput,
    BTable,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupText,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    existingSubscriptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      globalRate: {
        tax_rate: 15,
        tax_type: '',
      },
      rtbPartners: [],
      fields: [
        {
          key: 'subscribed',
          thStyle: { 'vertical-align': 'middle', width: '100px' },
          label: 'RtbPartnersControl.subscription',
        },
        {
          key: 'name',
          label: 'RtbPartnersControl.partner',
          thStyle: { 'vertical-align': 'middle' },
        },
        {
          key: 'fee',
          label: 'RtbPartnersControl.commission',
          thClass: 'text-center',
          thStyle: { 'vertical-align': 'middle', width: '150px' },
        },
        {
          key: 'limit',
          label: 'RtbPartnersControl.dailyBudgetLimit',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '150px' },
        },
        {
          key: 'godMode',
          label: 'RtbPartnersControl.godMode',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { 'vertical-align': 'middle', width: '100px' },
        },
      ],
    }
  },
  watch: {
    rows: {
      immediate: true,
      handler(rows) {
        this.rtbPartners = rows.map(partner => {
          // Ищем существующую подписку для этого партнёра
          const existingSub = this.existingSubscriptions.find(sub => sub.id === partner._id)

          return {
            _id: partner._id,
            name: partner.name,
            status: partner.status,
            subscribed: !!existingSub,
            god_mode: existingSub ? existingSub.god_mode : false,
            tax_rate: existingSub ? existingSub.tax_rate : this.globalRate.tax_rate,
            tax_type: existingSub ? existingSub.tax_type : '',
            daily_limit: existingSub ? existingSub.daily_limit : 0,
            hasDailyLimit: existingSub ? !!existingSub.daily_limit : false,
          }
        }).sort((a, b) => {
          // Сначала активные подписки
          if (a.subscribed && !b.subscribed) return -1
          if (!a.subscribed && b.subscribed) return 1
          // Затем по статусу партнёра
          if (a.status === 'active' && b.status !== 'active') return -1
          if (a.status !== 'active' && b.status === 'active') return 1
          // По алфавиту
          return a.name.localeCompare(b.name)
        })
      },
    },
    existingSubscriptions: {
      immediate: true,
      handler() {
        // Пересчитываем данные при изменении существующих подписок
        if (this.rows.length > 0) {
          this.rtbPartners = this.rows.map(partner => {
            const existingSub = this.existingSubscriptions.find(sub => sub.id === partner._id)

            return {
              _id: partner._id,
              name: partner.name,
              status: partner.status,
              subscribed: !!existingSub,
              god_mode: existingSub ? existingSub.god_mode : false,
              tax_rate: existingSub ? existingSub.tax_rate : this.globalRate.tax_rate,
              tax_type: existingSub ? existingSub.tax_type : '',
              daily_limit: existingSub ? existingSub.daily_limit : 0,
              hasDailyLimit: existingSub ? !!existingSub.daily_limit : false,
            }
          }).sort((a, b) => {
            // Сначала активные подписки
            if (a.subscribed && !b.subscribed) return -1
            if (!a.subscribed && b.subscribed) return 1
            // Затем по статусу партнёра
            if (a.status === 'active' && b.status !== 'active') return -1
            if (a.status !== 'active' && b.status === 'active') return 1
            // По алфавиту
            return a.name.localeCompare(b.name)
          })
        }
      },
    },
  },
  methods: {
    applyToAll() {
      const activeSubs = this.rtbPartners.filter(p => p.subscribed)
      if (!activeSubs.length) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Warning',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
            text: this.$t('RtbPartnersControl.noActiveSubscriptions'),
          },
        })
        return
      }

      this.rtbPartners.forEach(p => {
        if (p.subscribed) {
          p.tax_rate = this.globalRate.tax_rate
          p.tax_type = this.globalRate.tax_type
        }
      })
    },
    getRowClass(item) {
      return item && item.subscribed === false ? 'table-muted' : ''
    },
    handleGodModeChange(item) {
      // Если выбран godMode для текущего партнёра, снимаем с остальных
      if (item.god_mode) {
        this.rtbPartners.forEach(partner => {
          if (partner._id !== item._id) {
            partner.god_mode = false
          }
        })
      }
    },
    handleDailyLimitChange(item) {
      // Если изменено состояние ограничения по лимиту, обновляем данные
      if (item.hasDailyLimit) {
        item.daily_limit = 0 // По умолчанию, если ограничение включено, лимит должен быть 0
      }
    },
    // Метод для получения данных для сохранения
    getSubscriptionsData() {
      return this.rtbPartners
        .filter(partner => partner.subscribed)
        .map(partner => ({
          id: partner._id,
          daily_limit: partner.hasDailyLimit ? (partner.daily_limit || 0) : 0,
          god_mode: partner.god_mode || false,
          tax_rate: partner.tax_rate || 0,
          tax_type: partner.tax_type || '',
        }))
    },
  },
}
</script>

<style scoped>
.b-badge {
  font-size: 14px;
  padding: 0.5em 1em;
}
</style>

<style>
.table-muted {
  opacity: 0.5;
  pointer-events: none;
}
</style>
